import React from "react";
import { Controller } from "@hotwired/stimulus";
import { createRoot } from "react-dom/client";

import LinkAccountPopover from "src/customer/link_account_popover";

export default class extends Controller {
  static targets = ["popoverContainer"]

  declare popoverContainerTarget: HTMLElement;
  declare hasPopoverContainerTarget: boolean;

  connect() {
    if (this.hasPopoverContainerTarget) {
      this.renderPopover();
    }
  }

  private renderPopover() {
    const root = createRoot(this.popoverContainerTarget);
    root.render(
      React.createElement(LinkAccountPopover)
    );
  }
}
